import { Card, Stack, Typography } from '@mui/material'
import type { NotificationResource } from '../../../api/notifications'
import { getNotificationFallbackMessage, getNotificationFallbackTitle } from './utils'
import { NotificationEntityHeader } from './NotificationEntityHeader'

type Props = {
  notification: NotificationResource
}

export function FallbackNotificationCard({ notification }: Props) {
  const payload: any = (notification as any).payload ?? {}
  const payloadMessage = typeof payload?.message === 'string' ? payload.message.trim() : ''
  const message = payloadMessage.length > 0 ? payloadMessage : getNotificationFallbackMessage(notification)
  const subtitle = getNotificationFallbackTitle(notification)

  return (
    <Card variant="primaryAdaptiveCard" sx={{ p: 2 }}>
      <Stack direction="column" minWidth={0} flex={1} gap={1.25}>
        <NotificationEntityHeader
          title="Уведомление"
          fallbackIcon={
            <Typography variant="black-14-normal" sx={{ color: 'inherit' }}>
              i
            </Typography>
          }
          subtitle={subtitle}
        />

        <Typography variant="black-14-normal" sx={{ opacity: 0.9 }}>
          {message}
        </Typography>

        <Typography variant="black-12-light" noWrap sx={{ opacity: 0.8 }}>
          {notification.read_at ? 'Прочитано' : 'Непрочитано'} • {new Date(notification.created_at).toLocaleString()}
        </Typography>
      </Stack>
    </Card>
  )
}

